import { jsxs as t, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as V } from "./index.es2447.js";
function i({ size: l = V }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { y: "0.936646", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C("path", { d: "M17.5 17.0033H38.5V40.9366H17.5V17.0033Z", fill: "white" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M16.5625 22.9366C16.5625 25.1071 18.3295 26.8741 20.5 26.8741C22.2518 26.8741 23.7407 25.7232 24.25 24.138C24.7593 25.7232 26.2482 26.8741 28 26.8741C29.7518 26.8741 31.2407 25.7232 31.75 24.138C32.2593 25.7232 33.7482 26.8741 35.5 26.8741C37.6705 26.8741 39.4375 25.1071 39.4375 22.9366V17.4991H16.5625V22.9366Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M22.823 30.4366C22.3685 30.4366 22 30.8051 22 31.2597V40.9366H28V31.2597C28 30.8051 27.6315 30.4366 27.177 30.4366H22.823Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M29.75 31.1866C29.75 30.9105 29.9739 30.6866 30.25 30.6866H34.75C35.0261 30.6866 35.25 30.9105 35.25 31.1866C35.25 31.4628 35.0261 31.6866 34.75 31.6866H30.25C29.9739 31.6866 29.75 31.4628 29.75 31.1866Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M29.75 34.1866C29.75 33.9105 29.9739 33.6866 30.25 33.6866H34.75C35.0261 33.6866 35.25 33.9105 35.25 34.1866C35.25 34.4628 35.0261 34.6866 34.75 34.6866H30.25C29.9739 34.6866 29.75 34.4628 29.75 34.1866Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.0625 16.9991H39.9375V22.9366C39.9375 24.2277 39.3832 25.3918 38.5 26.2035V40.9366H17.5V26.2035C16.6169 25.3918 16.0625 24.2277 16.0625 22.9366V16.9991ZM37.5 39.9366H28V31.2597C28 30.8051 27.6315 30.4366 27.177 30.4366H22.823C22.3685 30.4366 22 30.8051 22 31.2597V39.9366H18.5V26.8973C19.1013 27.2022 19.781 27.3741 20.5 27.3741C22.0758 27.3741 23.4625 26.5483 24.25 25.3068C25.0375 26.5483 26.4242 27.3741 28 27.3741C29.5758 27.3741 30.9625 26.5483 31.75 25.3068C32.5375 26.5483 33.9242 27.3741 35.5 27.3741C36.219 27.3741 36.8987 27.2022 37.5 26.8973V39.9366ZM23 39.9366H27V31.4366H23V39.9366ZM24.5625 17.9991H31.0625V22.9366C31.0625 23.3489 31.119 23.7481 31.2247 24.1271C30.739 25.4371 29.4761 26.3741 28 26.3741C26.1056 26.3741 24.5625 24.831 24.5625 22.9366V17.9991ZM23.5625 17.9991V22.9366C23.5625 23.3489 23.619 23.7481 23.7247 24.1271C23.239 25.4371 21.9761 26.3741 20.5 26.3741C18.6056 26.3741 17.0625 24.831 17.0625 22.9366V17.9991H23.5625ZM32.0625 17.9991V22.9366C32.0625 24.831 33.6056 26.3741 35.5 26.3741C37.3944 26.3741 38.9375 24.831 38.9375 22.9366V17.9991H32.0625Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
i.__tags = [];
export {
  i as MetricStoreIcon
};
//# sourceMappingURL=index.es424.js.map
